import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large contact-container"
  }, [_c("BackgroundVideo"), _c("div", {
    staticClass: "container-centered small"
  }, [_vm.stepContact == 1 ? _c("div", [_c("div", {
    staticClass: "user-infos"
  }, [_c("h2", [_vm._v("Your information")]), _c("div", {
    staticClass: "user-infos-details"
  }, [_c("div", [_c(VTextField, {
    attrs: {
      label: "First name",
      placeholder: "John"
    },
    model: {
      value: _vm.input.first_name,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "first_name", $$v);
      },
      expression: "input.first_name"
    }
  }), _vm.errorLabels.first_name.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.first_name) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Last name",
      placeholder: "Doe"
    },
    model: {
      value: _vm.input.last_name,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "last_name", $$v);
      },
      expression: "input.last_name"
    }
  }), _vm.errorLabels.last_name.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.last_name) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Email",
      placeholder: "john.doe@domain.com"
    },
    model: {
      value: _vm.input.email,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "email", $$v);
      },
      expression: "input.email"
    }
  }), _vm.errorLabels.email.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.email) + " ")]) : _vm._e()], 1)])]), _c("div", {
    staticClass: "contact-infos"
  }, [_c("h2", [_vm._v("Your request")]), _c("div", [_c(VTextField, {
    attrs: {
      label: "Subject",
      placeholder: "Subject of your request",
      autofocus: ""
    },
    model: {
      value: _vm.input.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "subject", $$v);
      },
      expression: "input.subject"
    }
  }), _vm.errorLabels.subject.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.subject) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextarea, {
    attrs: {
      name: "Your message",
      label: "Leave us a message here"
    },
    model: {
      value: _vm.input.message,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "message", $$v);
      },
      expression: "input.message"
    }
  }), _vm.errorLabels.message.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.message) + " ")]) : _vm._e()], 1)]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    class: _vm.isUserConnected ? "dfwa-btn --with-dark-bg" : "send-button",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.makeRequest();
      }
    }
  }, [_vm._v(" Send ")])], 1)]) : _vm._e(), _vm.stepContact == 2 ? _c("div", [_c("h2", [_vm._v("Thank you for your request, " + _vm._s(_vm.input.first_name) + " " + _vm._s(_vm.input.last_name) + " !")]), _c("label", [_vm._v("We will get in touch as soon as possible !")]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.home();
      }
    }
  }, [_vm._v("Home")])], 1)]) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };